import type { EngineSnapshot } from '~/generated/api-clients-generated'

// for testing plan checkup flow before next years plans are available
export function remapEngineSnapshotYear(
  snapshot: EngineSnapshot,
  targetPlanYear: number
): EngineSnapshot {
  const remapped = JSON.parse(JSON.stringify(snapshot)) as EngineSnapshot

  remapped.params!.planYear = targetPlanYear
  remapped.params!.startYear = targetPlanYear
  remapped.plans?.forEach((plan) => {
    plan.year = targetPlanYear
  })

  return remapped
}
